import React, { FC, memo } from "react";
import { areEqualShallow } from "Utils/areEqual";

interface Props {
  classes: any;
  icon?: any;
  title?: any;
}
const PopUpContent: FC<Props> = memo(({ classes, icon, title = "" }: Props) => {
  return (
    <div className={classes.anchor}>
      <div className={classes.bubble}>
        <span className={classes.svgIcon}>{icon && icon}</span>
        {title.length > 0 && <span>{title}</span>}
      </div>
    </div>
  );
}, areEqualShallow);
PopUpContent.defaultProps = {
  title: undefined,
  icon: undefined,
};
export default PopUpContent;
try {
    // @ts-ignore
    PopUpContent.displayName = "PopUpContent";
    // @ts-ignore
    PopUpContent.__docgenInfo = { "description": "", "displayName": "PopUpContent", "props": { "classes": { "defaultValue": null, "description": "", "name": "classes", "required": true, "type": { "name": "any" } }, "icon": { "defaultValue": { value: "undefined" }, "description": "", "name": "icon", "required": false, "type": { "name": "any" } }, "title": { "defaultValue": { value: "undefined" }, "description": "", "name": "title", "required": false, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/DirectionsAndPopUps/PopUpContent.tsx#PopUpContent"] = { docgenInfo: PopUpContent.__docgenInfo, name: "PopUpContent", path: "src/shared/containers/DirectionsAndPopUps/PopUpContent.tsx#PopUpContent" };
}
catch (__react_docgen_typescript_loader_error) { }